<template>
    <div class="container">
        <div class="row">
            <heading>{{ $t('company.menuName') }}
                <template v-slot:actions>
                    <div class="input-group mr-4">
                        <input type="text" v-model="searchQuery" :placeholder="$t('core.search')" class="form-control" @keydown.enter="search">
                        <div class="input-group-append">
                            <button class="btn btn-outline-danger" type="button" @click="() => {searchQuery=''; search()}" v-show="searchQuery !== ''">
                                {{ $t('core.actions.clear') }}
                            </button>
                            <button class="btn btn-outline-secondary" type="button" @click="search">{{ $t('core.search') }}</button>
                        </div>
                    </div>
                    <a href="/customers/create" class="btn btn-primary">{{ $t('core.actions.new') }}</a>
                </template>
            </heading>
        </div>
        <div class="row">
            <div class="card col-12">
                <div class="card-body">
                    <div v-for="(customer,customerIndex) in customers" :class="{'text-muted bg-light': customer.deleted_at !== null}">
                        <div class="row border-top border-grey py-2">
                            <div class="col-4 user-select-none">{{ customer.lgt_customer_number }}</div>
                            <div class="col-4 user-select-none">{{ customer.name }}</div>
                            <div class="col-4 text-right">
                                <a :href="'/company/' + customer.id" v-if="customer.deleted_at === null" class="btn btn-sm btn-outline-primary">{{
                                        $t('core.actions.edit')
                                    }}</a>
                                <button class="btn btn-outline-primary btn-sm" v-b-toggle="'accordion-' + customerIndex">{{ $t('company.users') }}</button>
                                <button @click="disable(customerIndex)" v-if="customer.deleted_at === null" class="btn btn-sm btn-outline-danger">{{ $t('core.actions.deactivate') }}</button>
                                <button @click="enable(customerIndex)" v-if="customer.deleted_at !== null" class="btn btn-sm btn-outline-primary">{{ $t('core.actions.activate') }}</button>
                            </div>
                        </div>
                        <b-collapse :id="'accordion-' + customerIndex" accordion="my-accordion" role="tabpanel">
                           <table class="table">
                               <thead>
                               <tr>
                                   <th>{{ $t('company.fields.username') }}</th>
                                   <th>{{ $t('company.fields.email') }}</th>
                                   <th><a :href="'company/' + customer.id + '/user/create'" class="btn btn-outline-primary btn-sm float-right" v-if="customer.deleted_at === null">{{ $t('user.add') }}</a></th>
                               </tr>
                               </thead>
                               <tbody>
                               <tr v-for="(user, userIndex) in customer.users">
                                   <td>{{ user.username }}</td>
                                   <td>{{ user.email }}</td>
                                   <td class="text-right">
                                       <a :href="'/impersonate/take/' + user.id" class="btn btn-outline-primary btn-sm" v-if="user.deleted_at === null">{{ $t('user.impersonate') }}</a>
                                       <a :href="'/user/' + user.id + '/edit'" class="btn btn-outline-primary btn-sm" v-if="user.deleted_at === null">{{ $t('core.actions.edit') }}</a>
                                       <a :href="'/change-password/' + user.id" v-if="user.deleted_at === null"
                                          class="btn btn-sm btn-outline-primary">{{ $t('user.changePassword') }}</a>
                                       <button @click="deactivateUser(customerIndex, userIndex)" v-if="user.deleted_at === null" class="btn btn-sm btn-outline-danger">{{ $t('core.actions.deactivate') }}</button>
                                       <button @click="reactivateUser(customerIndex, userIndex)" v-if="user.deleted_at !== null && customer.deleted_at === null" class="btn btn-sm btn-outline-primary">{{ $t('core.actions.activate') }}</button>
                                   </td>
                               </tr>
                               </tbody>
                           </table>
                        </b-collapse>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BCollapse, VBToggle } from 'bootstrap-vue'

export default {
    name: 'CustomerIndex',
    directives: { 'b-toggle': VBToggle },
    components: { BCollapse },
    data: () => {
        return {
            customers: lgt.customers,
            searchQuery: '',
        }
    },
    methods: {
        disable (index) {
            axios.post('customer/disable', { customer: this.customers[index].id }).then((response) => {
                this.customers[index].deleted_at = new Date()
                this.customers[index].users.forEach((item, userIndex) => {
                    this.customers[index].users[userIndex].deleted_at = new Date();
                })
            })
        },
        enable (index) {
            axios.post('customer/enable', { customer: this.customers[index].id }).then((response) => {
                this.customers[index].deleted_at = null
            })
        },
        search () {
            axios.post('/customers/search', { query: this.searchQuery }).then((response) => {
                this.customers = response.data.customers
            })
        },
        deactivateUser(customerIndex, userIndex){
            axios.post('user/' + this.customers[customerIndex].users[userIndex].id + '/deactivate').then((response) => {
                this.customers[customerIndex].users[userIndex].deleted_at = new Date()
            })
        },
        reactivateUser(customerIndex, userIndex){
            axios.post('user/' + this.customers[customerIndex].users[userIndex].id + '/reactivate').then((response) => {
                this.customers[customerIndex].users[userIndex].deleted_at = null
            })
        }
    },
}
</script>
